import PartnerProfileModuleConfiguration from "./PartnerProfileModuleConfiguration";
import {PartnerProfileController} from "./controller/profile/PartnerProfileController";

PartnerProfileModuleConfiguration.createNewModule()
    .controller('partnerProfileController', PartnerProfileController.instanceConstructor);